import React, { useState } from 'react';
import { ContactUS } from '../../assets/images/index';
import { MdPhone } from "react-icons/md";
import { MdLocationPin } from 'react-icons/md';
import { MdEmail } from 'react-icons/md';
import { motion } from 'framer-motion';
import emailjs from 'emailjs-com';
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
const ContactUs = () => {
    // Form State
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        description: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const phoneRegex = /^[0-9]{10}$/;
    const disposableEmailRegex = /(mailinator|guerrillamail|10minutemail|temp-mail)\.com/;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.firstName || !formData.lastName || !formData.phone || !formData.email) {
            alert("Please fill in all required fields.");
            return;
        }
        if (!phoneRegex.test(formData.phone)) {
            alert("Please enter a valid 10-digit phone number.");
            return;
        }
        if (disposableEmailRegex.test(formData.email)) {
            alert("Disposable email addresses are not allowed. Please use a valid email.");
            return;
        }
        setIsSubmitting(true);

        emailjs
            .sendForm(
                'service_b8kscud',  // Replace with your EmailJS service ID
                'template_vutrqtd',  // Replace with your EmailJS template ID
                e.target,
                'MqQyhNaK8rAGNb_kX'       // Replace with your EmailJS user ID
            )
            .then(
                (result) => {
                    console.log('Email Sent:', result.text);
                    setFormData({
                        firstName: '',
                        lastName: '',
                        phone: '',
                        email: '',
                        description: '',
                    });
                    alert('Thank you for your response. We will reach you soon!')
                    setIsSubmitting(false);
                },
                (error) => {
                    console.log('Error:', error.text);
                    setIsSubmitting(false);
                }
            );
    };
    const splitTextArray = (text) => {
        return text.split("").map((char, index) => (
            <motion.span
                key={index}
                initial={{ opacity: 0, y: -10 }} // Start slightly above
                animate={{ opacity: 1, y: 0 }}   // Animate to normal position
                transition={{
                    delay: index * 0.05, // Faster staggered effect for characters
                    duration: 0.3,
                    ease: "easeOut",
                }}
                className="inline-block"
            >
                {char === " " ? "\u00A0" : char} {/* Preserve spaces */}
            </motion.span>
        ));
    };

    return (
        <div>
            <motion.div
                className="bg-cover bg-center bg-no-repeat w-full h-screen min-h-[300px] backdrop-blur-sm"
                style={{
                    backgroundImage: `url(${ContactUS})`,
                    backgroundSize: 'cover', // Cover the entire container (ensure the image always covers the space)
                    backgroundPosition: 'center', // Keep the image centered
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                whileInView={{ opacity: 1, y: 0 }} // Slide in from the top when in view
                viewport={{ once: true }} // Triggers animation when in view
            >
                <div className="flex justify-center items-center my-auto flex-col gap-[15px] fontText">
                    <div className="font-semibold text-[65px] text-[#ffffff] mt-[200px] max-md:text-[42px]">
                        {splitTextArray('Contact Us')}
                    </div>
                </div>
            </motion.div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 3, delay: 1 }}
                whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                viewport={{ once: true }}
                className="container py-[100px]">
                <div className='flex flex-row items-center gap-[30px] max-md:flex-col'>
                    <div className='w-[320px] h-[123px] flex flex-col justify-center items-center  bg-[#F2F0F0]' style={{ borderRadius: `0 40px 0 40px` }}>
                        <div className="fontText">
                            <h5 className='fontText text-[22px] font-semibold'>Phone Number</h5>
                        </div>
                        <div className="flex flex-row gap-[10px] items-center">
                            <MdPhone size="25px" color="black" />
                            <a href="tel:+916353886588" className='fontText text-[16px]'>
                                +91 6353886588
                            </a>
                        </div>
                    </div>
                    <div className='w-[320px] h-[123px] flex flex-col justify-center items-center  bg-[#F2F0F0]' style={{ borderRadius: `0 40px 0 40px` }}>
                        <div className="fontText">
                            <h5 className='fontText text-[22px] font-semibold'>Location</h5>
                        </div>
                        <div className="flex flex-row gap-[10px] items-center">
                            <MdLocationPin size="25px" color="black" />
                            <p className='fontText text-[16px] max-w-[240px]'>
                                <a 
    href="https://maps.app.goo.gl/eR6im4HnRH3qKFng7" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="hover:none"
  >
    TF - 27 Siddheshwar Hallmark, Ajwa Road, Vadodara - 390019
  </a>
                            </p>
                        </div>
                    </div>
                    <div className='w-[320px] h-[123px] flex flex-col justify-center items-center  bg-[#F2F0F0]' style={{ borderRadius: `0 40px 0 40px` }}>
                        <div className="fontText">
                            <h5 className='fontText text-[22px] font-semibold'>Email</h5>
                        </div>
                        <div className="flex flex-row gap-[10px] items-center">
                            <MdEmail size="25px" color="black" />
                            <a
                                href="mailto:shreedattguru03@gmail.com"
                                className="hover:underline"
                            >
                                shreedattguru03@gmail.com
                            </a>
                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 2, delay: 1.2 }}
                whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                viewport={{ once: true }}
                className='container pb-[100px]'>
                <div className='flex flex-row items-start gap-[40px] w-full max-md:flex-col'>
                    <div className='w-[35%] max-md:w-[100%] max-md:px-[20px]'>
                        <h4 className='fontText text-[55px] font-bold max-md:text-center'>GET IN<br /> TOUCH!</h4>
                        <p className='fontText text-[22px] font-semibold max-md:text-center'>Have questions or ready to start your project? Reach out to us! We’re here to help and will respond promptly to all inquiries.</p>
                        <div className='flex flex-row items-center gap-[20px] mt-[20px] max-md:justify-center'>
                            <a href="/" className="hover:text-secondary duration-200">
                                <FaWhatsapp className="text-3xl" color="green" />
                            </a>
                            <a href="/" className="hover:text-secondary duration-200">
                                <FaFacebook className="text-3xl" color="blue" />
                            </a>
                            <a href="/" className="hover:text-secondary duration-200">
                                <FaInstagram className="text-3xl" color="#E1306C" />
                            </a>
                        </div>
                    </div>
                    <div className='h-[full] w-[100%] bg-[#F2F0F0] max-md:px-[20px] max-md:rounded-[20px]'>
                        <div className='py-[80px]'>
                            <form onSubmit={handleSubmit}>
                                <div className='flex flex-col item-center gap-[40px] px-[40px] max-md:gap-[20px] max-md:px-[0]'>
                                    <div className='flex flex-row item-center max-md:flex-col gap-[20px]'>
                                        <input
                                            name="firstName"
                                            placeholder='First Name'
                                            type='text'
                                            className='w-full rounded-[10px] text-start pl-[30px] h-[52px]'
                                            value={formData.firstName}
                                            required
                                            onChange={handleChange}
                                        />
                                        <input
                                            name="lastName"
                                            placeholder='Last Name'
                                            type='text'
                                            className='w-full rounded-[10px] text-start pl-[30px] h-[52px]'
                                            value={formData.lastName}
                                            required
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className='flex flex-row item-center gap-[20px] max-md:flex-col'>
                                        <input
                                            name="phone"
                                            placeholder='Phone Number'
                                            type='number'
                                            className='w-full rounded-[10px] text-start pl-[30px] h-[52px]'
                                            value={formData.phone}
                                            required
                                            onChange={handleChange}
                                        />
                                        <input
                                            name="email"
                                            placeholder='Email'
                                            type='email'
                                            className='w-full rounded-[10px] text-start pl-[30px] h-[52px]'
                                            value={formData.email}
                                            required
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <input
                                            name="description"
                                            placeholder='Description'
                                            type='text'
                                            className='w-full rounded-[10px] h-[104px]'
                                            value={formData.description}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <button
                                            type="submit"
                                            className='w-full bg-[#ffffff] text-center h-[52px] rounded-[10px] text-[18px] font-semibold'
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Submitting...' : 'Submit Now'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </motion.div>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 4, delay: 3 }}
                whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                viewport={{ once: true }}
                className="w-full h-[300px] mb-[100px]">
                <iframe title="Google Maps Location" width="100%" height="100%" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d922.7497417538166!2d73.24358632406333!3d22.31589035861392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fcf8e34eeed21%3A0x1eb7157a1ea2a842!2sSiddheshwar%20Hallmark!5e0!3m2!1sen!2sin!4v1742044289943!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" />
            </motion.div>
        </div>
    );
};

export default ContactUs;
